import {useTranslation} from "react-i18next";
import {GenerateInputs} from "../GenericInputField";
import React, {useRef} from "react";
import Typography from "@material-ui/core/Typography";
import {ValidatorForm} from "react-form-validator-core";

function WriteCommentBox(props) {
    const {t, i18n} = useTranslation();
    let inputs = GenerateInputs({
        message: {
            required: true,
            defaultValue: props.globalComment,
            label: t("dialog_write_comment"),
            type: "textarea"
        }
    });

    let inputRef = useRef(null);
    let messageWrapper = useRef(null);

    let submit = () => {
        props.setGlobalComment(inputs.message.value);
    };

    props.dialog.ok = () => {
        return submit();
    };

    return <div style={{minWidth: 300}}>
        <Typography variant={"body1"}>{props.help || t("dialog_write_comment_help")}</Typography>
        <div>
            <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                <div ref={messageWrapper}>
                    {inputs.message.field}
                </div>
            </ValidatorForm>
        </div>
    </div>;
}

export default WriteCommentBox;